import Icon from '@ant-design/icons'
import { createSelector } from '@reduxjs/toolkit'

import './index.less'
import type { MenuProps } from 'antd'
import { Dropdown } from 'antd'
import React, { useState } from 'react'
import { createPortal } from 'react-dom'
import { arrowDownIcn, keypairIcn, logOutIcn, manageUserIcn, userIcn } from '../../../assets/CustomIcons'
import logo_horizontal from '../../../assets/logo_horizontal.svg'
import { useGetPractitionerQuery } from '../../../core/api/practitionerApi'
import { useAppDispatch, useAppSelector } from '../../../core/hooks'
import { CardinalApiState, logout } from '../../../core/services/auth.api'
import { ModalAccessRecoveryKey } from '../../practitioner-elements/ModalAccessRecoveryKey'
import { ModalManageAccountForm } from '../../practitioner-elements/ModalManageAccountForm'

const reduxSelector = createSelector(
  (state: { cardinalApi: CardinalApiState }) => state.cardinalApi,
  (cardinalApi: CardinalApiState) => ({
    user: cardinalApi.user,
    healthcarePartyId: cardinalApi.user?.healthcarePartyId,
    userId: cardinalApi.user?.id,
  }),
)
export const Header = () => {
  const [isUserDropdownOpen, setUserDropdownOpen] = useState(false)
  const [isModalManageAccountFormOpen, setModalManageAccountFormOpen] = useState(false)
  const [isAccessRecoveryKeyModalOpen, setAccessRecoveryKeyModalOpen] = useState(false)
  const dispatch = useAppDispatch()

  const { healthcarePartyId } = useAppSelector(reduxSelector)

  const { data: practitioner, isFetching: isPractitionerFetching } = useGetPractitionerQuery(healthcarePartyId ?? '', { skip: !healthcarePartyId })

  const handleLogout = () => {
    dispatch(logout())
  }

  const items: MenuProps['items'] = [
    {
      key: 'manageAccount',
      label: (
        <div className="header__userDropdown__item">
          <Icon component={manageUserIcn} />
          <span>Manage account</span>
        </div>
      ),
    },
    {
      key: 'accessRecoveryKey',
      label: (
        <div className="header__userDropdown__item">
          <Icon component={keypairIcn} />
          <span>Access recovery key</span>
        </div>
      ),
    },
    {
      key: 'logout',
      danger: true,
      label: (
        <div className="header__userDropdown__item">
          <Icon component={logOutIcn} />
          <span>Log out</span>
        </div>
      ),
    },
  ]
  const onClick: MenuProps['onClick'] = ({ key }) => {
    switch (key) {
      case 'manageAccount': {
        setModalManageAccountFormOpen(true)
        break
      }
      case 'accessRecoveryKey': {
        setAccessRecoveryKeyModalOpen(true)
        break
      }
      case 'logout': {
        handleLogout()
        break
      }
    }
  }

  return (
    <>
      {/*<div className="headerBanner">*/}
      {/*  <p>*/}
      {/*  </p>*/}
      {/*</div>*/}

      <div className="header">
        <div className="header__logoHolder">
          <img src={logo_horizontal} alt="petraCare logo" />
        </div>
        {!isPractitionerFetching && (
          <Dropdown menu={{ items, onClick }} placement="bottomRight" arrow onOpenChange={(open: boolean) => setUserDropdownOpen(open)}>
            <div className={`header__userDropdown ${isUserDropdownOpen && 'header__userDropdown--active'}`}>
              <div className="header__userDropdown__heading">
                <p className="header__userDropdown__heading__name">{practitioner?.firstName + ' ' + practitioner?.lastName}</p>
                <p className="header__userDropdown__heading__ssin">{practitioner?.ssin ?? 'SSIN is not provided'}</p>
              </div>
              <div className="header__userDropdown__userAvatarPlaceholder">
                <Icon component={userIcn} />
              </div>
              <div className="header__userDropdown__arrow">
                <Icon component={arrowDownIcn} />
              </div>
            </div>
          </Dropdown>
        )}
      </div>
      {isModalManageAccountFormOpen &&
        createPortal(
          <ModalManageAccountForm isVisible={isModalManageAccountFormOpen} onClose={() => setModalManageAccountFormOpen(false)} practitionerToBeUpdated={practitioner} />,
          document.body,
        )}
      {isAccessRecoveryKeyModalOpen &&
        createPortal(<ModalAccessRecoveryKey isVisible={isAccessRecoveryKeyModalOpen} onClose={() => setAccessRecoveryKeyModalOpen(false)} />, document.body)}
    </>
  )
}
